import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { api } from "../lib/api";
import { TrendingUp } from "lucide-react";

export function CheckinTrendChart() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/admin/checkins-trend", { params: { weeks: 8 } }).then((r) => setData(r.data)).catch(() => {}); }, []);
  const totS = data.reduce((a, d) => a + d.scheduled, 0);
  const totC = data.reduce((a, d) => a + d.completed, 0);
  const rate = totS ? Math.round((totC / totS) * 100) : 0;

  return (
    <section className="glass rounded-2xl p-5" data-testid="checkins-trend-chart">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <TrendingUp className="h-5 w-5 text-emerald-400" />
        <h2 className="font-display font-bold text-lg">Andamento check-in · ultime 8 settimane</h2>
        <span className="ml-auto text-xs text-slate-400" data-testid="checkins-trend-rate">
          Completamento team: <strong className="text-emerald-300">{rate}%</strong> ({totC}/{totS})
        </span>
      </div>
      <div className="h-64 min-h-[16rem] w-full min-w-0">
        <ResponsiveContainer width="100%" height="100%" minHeight={256}>
          <BarChart data={data} barGap={4}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" vertical={false} />
            <XAxis dataKey="label" stroke="#64748b" fontSize={11} tickLine={false} />
            <YAxis stroke="#64748b" fontSize={11} allowDecimals={false} tickLine={false} axisLine={false} />
            <Tooltip cursor={{ fill: "rgba(255,255,255,0.04)" }}
              contentStyle={{ background: "#14161d", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, fontSize: 12 }}
              labelFormatter={(l) => `Settimana dal ${l}`} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="scheduled" name="Programmati" fill="#f59e0b" radius={[6, 6, 0, 0]} />
            <Bar dataKey="completed" name="Completati" fill="#10b981" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
